import React, { useRef } from "react";
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PromocodesTable from '../../components/Promocodes/PromocodesTable.js';
import PromocodeForm from '../../components/Promocodes/PromocodeForm.js';
import Toast from '../../components/Toast/toast.js';
import { useLanguage } from '../../utils/languageContext.js';
import { getTranslation } from '../../utils/translate.js';

const Promocodes = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const params = useParams();
    const { language } = useLanguage();
    const toastRef = useRef(null);
    
    // Determine current view from URL path
    const getCurrentView = () => {
        const path = location.pathname;
        
        if (path === '/promocodes/create') {
            return { view: 'form', mode: 'create', promocodeId: null };
        } else if (path.startsWith('/promocodes/edit/')) {
            return { view: 'form', mode: 'edit', promocodeId: params.id };
        } else {
            return { view: 'table', mode: null, promocodeId: null };
        }
    };

    const { view, mode, promocodeId } = getCurrentView();

    const handleCreatePromocode = () => {
        navigate('/promocodes/create');
    };

    const handleEditPromocode = (id) => {
        navigate(`/promocodes/edit/${id}`);
    };

    const handleBackToTable = () => {
        navigate('/promocodes');
    };

    const handleFormSuccess = () => {
        // Show success message and go back to table
        handleBackToTable();
    };

    return (
        <div className="pl-2">
            {view === 'table' ? (
                <>
                    <h1 className="text-xl font-bold mb-4 text-gray-900 dark:text-[#c9d1d9]">{getTranslation('promocodes.title', language)}</h1>
                    <PromocodesTable
                        onCreatePromocode={handleCreatePromocode}
                        onEditPromocode={handleEditPromocode}
                        toastRef={toastRef}
                    />
                </>
            ) : (
                <PromocodeForm
                    mode={mode}
                    promocodeId={promocodeId}
                    onCancel={handleBackToTable}
                    onSuccess={handleFormSuccess}
                    toastRef={toastRef}
                />
            )}
            <Toast ref={toastRef} />
        </div>
    );
};

export default Promocodes;
